import React from "react";

function Reports() {
  return (
    <div className="space-y-6">

      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Reports</h1>
        <p className="text-sm text-gray-500">
          Overview of CRM performance
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">

        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Total Revenue</p>
          <h2 className="text-2xl font-semibold text-gray-800">
            ₹ 1,25,000
          </h2>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Closed Deals</p>
          <h2 className="text-2xl font-semibold text-gray-800">
            32
          </h2>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">New Leads</p>
          <h2 className="text-2xl font-semibold text-gray-800">
            58
          </h2>
        </div>

      </div>

    </div>
  );
}

export default Reports;
